// hooks/useFileUploader.ts
import { useState } from "react";
import { BlobServiceClient, ContainerClient } from "@azure/storage-blob";
import { config } from "../Features/Services/config";
import useApi from "../Features/Services/ServiceClient";
import axios from "axios";

export const useFileUploader = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [uploadedUrl, setUploadedUrl] = useState<string | null>(null);
    const [uploadedImageName, setUploadedImageName] = useState<string | null>(null);
    const { GET } = useApi();

    const uploadFile = async (containerName, file) => {
        if (!file) {
            setError("No file provided");
            return;
        }

        try {
            setLoading(true);
            setError(null);

            // 1. Get SAS token from API
            const sasResponse = await GET(`${config.file_uploader.END_POINTS.UPLOAD_FILE_URL}/${containerName}/${file.name}`);

            console.log("SAS Response:", sasResponse);

            // 2. Use SAS URL to init BlobServiceClient
            const blobServiceClient = new BlobServiceClient(sasResponse.locationUrl);

            // 3. Get container + blob client
            const containerClient = blobServiceClient.getContainerClient("");

            // 3. Get Blob Client (use server-generated newFileName if needed)
            const blobClient = containerClient.getBlockBlobClient("");
            // const blobClient = containerClient.getBlockBlobClient(sasResponse.newFileName);

            // 4. Upload file
            // const response = await blobClient.uploadData(file, {
            //     blobHTTPHeaders: { blobContentType: file.type },
            // });

            const response = await fetch(sasResponse.locationUrl, {
                method: "PUT",
                headers: {
                    "x-ms-blob-type": "BlockBlob", // required
                    "Content-Type": file.type,
                },
                body: file,
            });

            console.log("Azure upload response:", response);

            const uploadedImageUrl = `${process.env.REACT_APP_UPLOAD_URL}${containerName}/${sasResponse.newFileName}`;

            setUploadedUrl(uploadedImageUrl);
            setUploadedImageName(sasResponse.newFileName);
            return sasResponse.newFileName;
        } catch (err: any) {
            setError(err.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    return { uploadFile, loading, error, uploadedUrl, uploadedImageName };
};
